<style scoped>
.contet_title {
  font-size: 22px;
  padding-top: 25px;
  padding-bottom: 20px;
  text-align: center;
  font-weight: bold;
}
.content--box {
    padding: 15px;
    box-sizing: border-box;
}
</style>

<template>
  <div>
    <div class="contet_title">
      {{ title }}
    </div>
    <div class="content--box">
      <h1 style="text-indent: 2em">第一章 总则</h1>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        一、【概述】
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第一条
        买卖双方在美滋来平台（以下称平台）上进行交易，关于交易订单的履行过程中，作为标的物的商品的生产、流通和交付，一方产生违反交易订单的合同约定的行为，导致出现纠纷争议，适用本规则。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二条
        买家（或卖家）向卖家（或买家）主张违约责任承担，向平·台投诉的，平台将根据本规则进行处理，平台其他规则有特别规定的，优先根据特别规定处理。当卖家店铺因自身系统、管理、人力、仓储等原因出现异常大量违约事件或舆情事件，且卖家不具备处理能力的，为保障买卖双方交易安全，平台可主动介入处理。部分买卖双方的争议，买家有权选择或平台根据争议内容交由公众评审判断，平台将根据公众评审的判断结果对该等争议作出处理。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三条
        平台通过平台系统、短信或电话等方式向买卖双方发送的与争议处理相关的提示或通知，构成争议处理依据及结论的有效组成部分。
      </p>
      <h1 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二章 争议受理
      </h1>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px">一、【受理期限】</span>
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四条 买家应在平台规定的时限内在线发起投诉。&nbsp;
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五条 以下六种情形不受受理期限的限制：
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1. 国家行政机关认定为假冒或违禁商品；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 买家提供国家司法机关出具的生效法律文书；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3.
        买家未在平台规定的时限内在线发起投诉，但能够提供凭证证实商品存在品质等相关问题；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        4. 卖家被国家监管机构进行了相关处罚；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        5. 双方另行约定交易合同履行起始时间；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        6. 其他国家法律、行政法规另有规定的。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px">二、【 受理范围】</span>
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六条
        美滋来受理买卖双方在平台上产生的交易争议处理申请，但出现以下情形的，平台可不予受理，买卖任一方有权自行通过司法机关等途径向相对方主张违约责任承担：
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1. 买家（卖家）未在本规则规定的受理期限内发起投诉；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2.
        交易订单显示的商品或服务与买卖双方约定的实际交易商品或服务不一致，导致交易事实无法查清；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3.
        买卖双方经自行协商达成违约责任承担并履行完毕，一方或双方反悔产生争议；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        4.
        买卖双方进行虚假交易或利用信用卡、平台积分、红包等实施套现且交易成功；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        5.
        交易订单取消后，争议已经判定违约责任承担并履行完毕，因卖家需要取回商品产生争议；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        6. 除平台规则规定的情形外，买家主张交易引发的额外损失或法定赔偿事宜。
      </p>
      <h1 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三章 争议处理的通用规则
      </h1>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第七条
        买卖双方就交易商品或服务事先有约定的，优先从约定；未事先约定或约定不明的，双方可协议补充；无法达成补充协议的，平台将按照本规则进行处理，本规则有特别规定的优先从特别规定。若仍无法确定争议的违约责任归属的，平台将按照交易习惯或出于实现合同的目的的方式进行处理。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第八条
        争议处理过程中，买卖双方应按本规则规定进行举证。本规则未有规定或平台发现双方的交易或一方账号存在异常的，平台将根据双方实际情形作出举证责任分配。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第九条
        买卖双方应自行对证据的真实性、完整性、有效性、准确性和及时性负责，平台将基于普通人的认知，根据该等证据作出违约责任承担的归属认定及承担方式的结论。如果在过程中或事后发现有一方提供的凭证中存在虚假或伪造，则当事人承担相关不利结果，情节严重者需承担法律责任。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十条
        买卖双方达成补充协议但一方否认的，主张协议无效的一方应提供有效证据予以证明，否则应承担相关不利后果。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十一条
        平台就买卖双方特定的违约行为规定违约方需要支付违约金的，当一方发生该违约行为，应向另一方支付，双方可授权平台代为操作。若平台规定的该违约行为需要支付的违约金与双方自行约定的数额不一致，则采取就高原则。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十二条
        平台应买卖双方需求及查明事实需要，必要时将向第三方核实违约责任承担的争议问题，并据此作为交易调处的参考依据。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十三条
        卖家交付买家的商品存在大量严重质量问题、大量出餐、配送、交付超时等情形的，经平台综合判断，有理由认为卖家已无履行合同之意图或能力的，视为卖家拒绝履约，出于保障买家权益的目的，支持买家向卖家主张违约责任承担，卖家向买家支付违约金，交易支持退款。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十四条
        卖家出售的商品被新闻媒体曝光、国家质监部门等行政管理部门通报，或经平台抽检或排查确认系描述不当、质量不合格的，支持买家向卖家主张违约责任承担，卖家向买家支付违约金，交易支持退款。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十五条
        卖家出售禁售商品或提供禁售服务的，交易将视情形做关闭订单和退款处理。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十六条 买家退货前若商品已不适宜退货，则作退款处理。&nbsp;
      </p>
      <h1 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四章 交易订单的履行
      </h1>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        一、【接单规范】
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十七条
        买家完成订单支付后，卖家应当在规定的时间内，完成接单确认并将信息告知到买家。因卖家超时未接单导致订单取消的，买家可向卖家主张违约责任承担，卖家向买家支付违约金，交易支持退款。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px">二、【发货规范】</span>
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        发货时效要求
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十八条本规则所称的“发货”，包含两个时间节点，具体按如下情形认定：
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1.
        商品的出货时间：卖家完成订单内容中的餐品或物品的生产、封装和打包，进入可配送状态的时间；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2.
        商品启动配送的时间：卖家将打包成功的商品委托到配送方，向收货地址出发进行配送的时间。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十九条
        卖家对同一个买家的每个独立生成并付款的交易订单（非购物车合并付款的订单）应予单独发货，并提供发货时间。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十条
        卖家应当在约定的期限内完成商品的实际出餐/出货，并将对应的时间及时、真实、准确的告知到买家，卖家未履行视为卖家违约，买家可申请取消订单或要求卖家支付违约金。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十一条
        卖家委托配送方进行配送时，应当保证向配送方提供的取货地址的准确性。当配送方因地址复杂而向卖家求助的时候，卖家应及时响应处理。由此导致的商品未在约定的时间期限内启动配送的风险，由卖家自行承担。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十二条
        卖家应当在约定的时间期限内完成将商品委托到配送方进行承运，开始向买家进行配送。由此导致的商品未在约定的时间期限内送达的，买家可向卖家主张违约责任承担，申请交易退款或要求卖家支付违约金。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十三条
        商品应该按照约定的时间期限内完成向买家的交付，卖家未履行的，买家可向卖家主张违约责任承担，申请交易退款或要求卖家支付违约金。卖家和配送方关于此事的责任承担，按照双方约定单独解决。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        发货内容要求
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十四条
        在委托配送方开始配送前，卖家应当校验打包封装的商品是否和订单内容完全一致，避免出现遗漏、错放等。卖家未履行的，买家可向卖家主张违约责任承担，申请交易全部/部分退款。卖家和配送方关于此事的责任承担，按照约定双方单独解决。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十五条
        在委托配送方开始配送前，卖家应当对商品进行良好封装和包装，避免在委托配送方进行配送过程中出现因包装问题而导致的破损、洒漏等问题。卖家未履行的，买家可向卖家主张违约责任承担，申请交易全部/部分退款。卖家和配送方关于此事的责任承担，按照约定双方单独解决。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十六条
        卖家违反发货规范导致买家超过约定期限未收到商品或拒收商品的，由此产生的相关费用及商品损毁、丢失、变质等风险，由卖家自行承担。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十七条
        卖家违反发货规范，买家可向卖家主张违约责任承担，申请交易退款、支付违约金、补发或者重发商品等。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十八条
        卖家违反发货规范但买家已实际使用商品或已点击“确认收货”的，买家以卖家违反发货规范为由而主张退款的，应先和卖家协商，否则平台将不予支持。因卖家的不正当行为诱使买家“确认收货”的情形除外。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px">三、【配送规范】</span>
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        主要对象为受卖家委托来进行订单商品交付的配送方，包括配送平台（商家自营配送方或美滋来提供的配送方）、快递或物流。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十九条 配送方应当及时到达商品的取货地点，完成取货并开始配送商品。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三十条
        配送过程中，配送方如遇到不可抗力导致无法继续配送或配送超时，应当及时通知买家和卖家。卖家在此事上并不承担对买家的违约责任，买家可选择要求重发或交易退款处理。卖家和配送方关于此事的责任承担，按照约定双方单独解决。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三十一条
        配送方应当按照约定期限向买家完成商品交付，双方另有约定情况除外。约定交付期限的，配送方不得晚于约定时间交付。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三十二条
        配送方应当在完成商品交付之后点击确认送达，完成交付时间的确认。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三十三条
        卖家因委托的配送方违反配送规范导致买家超过约定期限未收到商品或拒收商品的，由此产生的相关费用及商品损毁、丢失、变质等风险，由卖家自行承担。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三十四条
        卖家委托的配送方违反配送规范，买家可向卖家主张违约责任承担，申请交易退款、支付违约金、补发或重发商品等。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三十五条 卖家和配送方之间的违约责任承担，依照相互约定处理。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px">四、【售中订单取消规范】</span>
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三十六条 商品送达之前，当卖家出现下述违约事件时，买家可申请取消订单：
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1. 卖家未按约定时间期限接单；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2.
        卖家未按照约定时间期限提供出货信息/未及时提供出货信息/提供的出货信息不准确；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3. 商品超过约定时间期限未启动配送；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        4. 商品未按照约定的时间期限内送达。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三十七条
        商品送达之前，在卖家未违约的情况下，买家要求取消订单，需要按照下述要求：
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1.
        买家取消订单，需要和卖家先行沟通，卖家同意之后，买家可按照双方约定取消。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 如卖家未同意，买家坚持取消，则交易支持退款，买家须向卖家支付违约金。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px">五、【签收规范】</span>
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三十八条
        买家需确保订单中填写的信息真实、完整、准确、有效。因买家提供的信息错误导致未收到商品的，由买家承担该责任限度内的不利后果。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三十九条
        买家需变更收货信息中任一要素的，应征得卖家同意。卖家同意后实际未变更成功，商品仍按变更前的收货信息被签收，买家主张未收到商品的，经平台判断若变更前和变更后的收件信息和买家无显著关联的，交易支持退款买家，由卖家承担商品相应风险。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四十条
        卖家应将商品送达至买家订单收货地址并交由收件人本人签收，双方另有约定除外。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四十一条
        卖家发货后，收货人应亲自签收商品。收货人委托他人签收商品或配送方已按收货人的指示将商品置于指定地点的，视为收货人本人签收。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四十二条
        收货人应在配送方交付商品时，当场检视商品表面是否一致（如包装破损、洒漏等）。若发现商品表面不一致，可予以拍照并拒签，交易支持退款买家，由卖家承担商品损毁、丢失、变质的风险。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四十三条
        买家无正当理由拒绝签收商品，交易支持汇款卖家，由买家承担商品毁损、丢失、变质的风险，双方另有约定的情形除外。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四十四条
        买家主张未收到商品的，由卖家承担举证责任；买家与卖家协商需要退回商品但卖家主张未收到商品的，由买家承担举证责任，举证无效的，支持退款买家或汇款卖家。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px">六、【赠品规范】</span>
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四十五条
        赠品指买家以购买交易商品为前提而获得的卖家承诺或双方约定的赠予物或服务。卖家开展合法有奖销售的，买家中奖所获的奖品亦视为赠品，参照赠品规范处理。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四十六条
        卖家应当明示赠品的品种、规格、数量、服务项目等要素，若表述内容出现含混不清、有歧义等情形的，按交易习惯、实现交易合同目的或有利于消费者的原则进行认定。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四十七条
        卖家附赠的赠品若本身需要法定售卖资质的（如烟草等），则应当具备该资质方可进行附赠。否则，买家可要求按赠品的价值退还相应价款。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四十八条
        卖家赠品的发货时间应当和交易商品承诺或规定的发货时间相一致。双方对赠品发货时间另有约定的，从其约定。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四十九条
        买家签收交易商品后，赠品的争议处置结果不影响交易商品的争议处理。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五十条
        卖家赠品延迟发货的，将根据赠品价值并依照延迟发货相关规则进行处理。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五十一条 存在下述情形之一的，赠品退货事宜由卖家自行和买家协商解决：
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1. 卖家违反本规则第四十七条且买家要求退还赠品价款的；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 卖家过错致使交易商品退款或退货退款的；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3. 非因买家原因，赠品依其性质或性状不适宜退货或无法退货的。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五十二条
        赠品的价值计算：卖家对赠品价值事先予以声明的，按其声明价值；事先未予声明的，平台将参照赠品的市场公允价格酌定。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px"
          >七、【质量问题、假冒商品情形举证责任分配及争议处理】</span
        >
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五十三条
        买家主张商品存在质量问题系人眼可辨的，应提供初步凭证予以证明。买家未提供初步凭证的，交易支持汇款卖家。买家已提供凭证且平台初步认定的，卖家应针对买家给出的初步凭证作出合理解释或提供证据证明不存在质量问题；卖家未提供的，平台将认定质量问题属实。买家无法提供证明的，交易支持汇款卖家。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五十四条
        买家主张商品存在质量问题系人眼不可辩的或系假冒商品的，卖家应按照平台的要求，提供品牌或厂家的经销凭证、商业发票、原材料的进货记录、后厨环境等相关凭证以证明商品来源或出货的合规性。卖家无法提供的，交易支持退款。卖家已提供有效凭证的，买家应按平台要求及时提供有效的质检凭证或其他有效凭证。买家无法提供的，交易支持汇款；买家提供相应凭证的，平台将认定商品质量问题或假冒属实。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五十五条
        平台认定卖家出售的商品质量问题或假冒属实的，视为卖家违约，支持买家向卖家主张违约责任承担，要求卖家交易退款或履行重发、补发等义务，并承担相应法律责任。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五十六条
        商品因质量问题或假冒致使买家合同目的不能实现的，买家可申请取消订单，由此导致的商品破损、变质、丢失的风险由卖家承担。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五十七条
        商品存在一定瑕疵但尚未影响买家合同目的实现的，买家可申请部分退款。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五十八条
        应平台要求，商品经买家送检后证实为质量问题或假冒的，检测费用由卖家承担，若被检商品因检测而被物理破坏导致无法退货或无退货价值的，交易支持退款。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五十九条
        非应平台要求，买家仍将商品送检的，检测费用由买卖双方自行协商或依据相关法律法规处理。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px"
          >八、【描述不当、表面不一致情形举证责任分配及争议处置】</span
        >
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六十条
        买家主张商品存在描述不当系人眼可辨的，应当提供初步凭证予以证明，平台有权根据买家提供的凭证初步认定存在描述不当，卖家应对买家提供的凭证作出平台认可的合理解释或提供证据证明不存在描述不当，否则平台将认定描述不当属实。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六十一条
        买家主张商品描述不当系人眼不可辩的，平台将参照本规则“商品质量问题”条款进行举证责任分配。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六十二条
        买家主张商品存在表面不一致的，卖家应就收件人已按本规则“签收规范”之规定签收商品承担举证责任；卖家举证有效的，则由买家举证证明商品签收时即存在表面不一致情形。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六十三条
        买家主张商品存在表面不一致但已点击“确认收货”的，买家对主张商品存在表面不一致情形负举证责任。因卖家的不正当行为诱使买家确认收货的情形除外。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六十四条
        买家已证明商品签收时存在表面不一致的，买家可视商品性质及损失大小合理选择要求卖家承担补发、重发、换货等违约责任。卖家拒绝承担该等违约责任的，交易支持退款。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六十五条
        卖家已证明买家签收商品时不存在表面不一致的，交易支持汇款卖家。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六十六条
        商品因签收时存在破损，买卖双方协商一致致使交易作退货退款处理的，商品交付配送方后产生的损毁、灭失的风险根据双方约定由责任方承担。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px"
          >九、【不开发票情形举证责任分配及争议处理】</span
        >
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六十七条&nbsp;
        买家主张卖家存在不开发票、错开发票后拒不解决的行为，卖家需提供开票记录等举证证明，经平台认定卖家已正确开具发票的，交易支持汇款卖家；卖家无法举证已正确开具发票的，视为卖家侵权，需向买家承担侵权责任，要求卖家按照交易金额的一定比例支付补偿金额或部分退款。
      </p>
      <h1 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五章 撤销和中止
      </h1>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六十八条
        平台处理争议期间，出现以下任一情形的，平台将中止争议处理程序：
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1. 买卖双方一致要求中止，并约定期限自行协商处理争议。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 任何一方通知平台要求将争议提交司法机关或拟向公安机关报案。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六十九条 出现以下任一情形的，平台将恢复争议处理程序：
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1.
        一方通知平台要求通过司法机关解决争议或拟向公安机关报案的，未在通知平台后的7个工作日内向平台提供司法机关或公安机关的案件受理凭证。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 争议被司法机关撤诉。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3. 司法机关对争议作出判决且生效。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        4. 公安机关受理案件后的六个月后仍未对案件给出调查结论或处理建议。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6=""></p>
      <h1 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六章 执行
      </h1>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第七十条
        平台处理纠纷争议期间，买卖双方协商一致达成和解协议，但无法或不便自行操作的，平台有权根据双方达成的和解协议内容，代为操作相应的交易款项和(或)违约金。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第七十一条
        平台对争议做出处理后，有权按照处理结果将交易款项和（或）违约金的全部或部分支付给买家和(或)卖家，或协助卖家(或买家)按照处理结果将相关款项支付给买家(或卖家)。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第七十二条
        除交易款项外，根据争议处理结果仍需卖家承担赔偿责任的，平台有权划拨卖家根据平台相关协议缴纳的保证金（如有）或其他款项支付给买家。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第七十三条
        卖家账户余额不足致使无法退款或赔付的，由买卖双方自行协商或通过其他途径解决。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第七章 附则
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第七十四条
        对于交易过程中出现的当事人的民事权利被侵害，按照维权处理规则进行处理。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第七十五条
        平台活动或特殊服务对买卖双方争议处理有特殊要求的，按照特殊要求处理。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第七十六条
        本规则生效或变更后尚未处理完结的交易，适用生效或变更后的规则。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第七十七条
        平台对争议做出处理，并代为操作支付争议款项后，买家或(和)卖家对平台的处理有异议的，可向人民法院起诉。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第七十八条 附录定义
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1.
        运费，指发货/退货所产生的必要费用，如商品封装、打包、配送等相关费用以及运输费用等。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 退货退款，指在卖家签收买家退货后，交易款项支付给买家。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3. 部分退款，指交易款项部分支付给买家，余款汇款给卖家。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        4. 退款，指交易款项支付给买家，商品由卖家自行和买家协商处理。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        5. 汇款，指交易款项支付给卖家。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        6.
        破损，指商品的一般性损伤，经简单修复后仍可恢复全部使用功能或不影响核心功能使用，能实现合同目的。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        7.
        损毁，指商品严重受损，无法予以修复或修复后其核心功能已不具有使用价值或无法实现合同目的。修复成本接近商品价值的，视为损毁。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        8. 交易成功，指订单状态显示“配送完毕”。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        9.
        质量问题，指卖家出售的商品违反《中华人民共和国产品质量法》等法律规定或美滋来平台品质类相关规则要求。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        10. 表面不一致，指凭人眼即可判断标的物商品存在破损、少件、空包等情形。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        11.
        描述不当，指买家收到的商品或接受的服务，或经平台抽检、排查到的商品或服务存在与卖家描述不相符，如与商品介绍不符、商品有瑕疵（划痕、污渍）、商品瑕疵等信息未披露等情形，侵害买家的合法权益的行为。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        12. 配送方，指负责商品运输的配送平台、快递或物流一方。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        13.
        三包，指卖家根据国家相关的法律、行政法规，或美滋来公示的相关规则履行商品维修更换、退货的责任与义务。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <br />
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <strong>平台纠纷投诉卖家处理规范</strong>
      </p>
      <h1 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第一章 概述
      </h1>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第一条
        为维护美滋来平台（以下简称平台）交易秩序，指导卖家快速有效处理买家纠纷投诉，建设公开、透明、开放的市场环境，保障买卖双方权益，特制定本规范。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二条
        本规范适用于在美滋来平台上产生订单的买家通过平台、短信或电话等方式向卖家发起的纠纷申请及通过售后渠道方式向平台发起的投诉申请的处理。
      </p>
      <h1 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二章 卖家服务保障
      </h1>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三条 卖家应承担买家纠纷申请及投诉申请处理的首负责任及和解义务。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四条
        卖家应将店铺有效的客服电话公示在店铺简介、店铺公告等界面，并确保公示中的联系方式真实有效。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第五条
        卖家应配备相应人员对接处理买家纠纷投诉问题，并做好人员的专业技能培训工作。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第六条 卖家及其处理人员在处理纠纷投诉过程中，应做到：
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1.
        积极主动：积极响应买家的纠纷投诉问题，发掘买家真实诉求，处理过程中保持合理的沟通、跟进频率。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 尊重他人：卖家应耐心细致，与人友善，保障买家的人格尊严不受损害。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3.
        主动承担：对确属卖家的责任问题，主动承担，提出合理的解决方案，不推诿懈怠。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        4. 诚实信用：与买家达成一致协议后，保质保量兑现承诺或履行协议约定。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        5. 遵纪守法：处理纠纷投诉问题过程中遵守国家法律法规、平台规则相关要求。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第七条
        卖家应提高自身投诉处理能力，提高店铺投诉申请解决率，平台有权对卖家的投诉处理能力进行考核，并实施奖惩措施。
      </p>
      <h1 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三章 纠纷投诉问题处理操作流程
      </h1>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px">一、【响应要求】</span>
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第八条
        卖家应保证营业期间网络、电话等纠纷投诉端口顺畅，及时关注端口新进纠纷投诉问题。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第九条
        卖家应在规定时间内响应接收到的纠纷投诉申请，通过买家提供的文件凭证、交易快照等信息，初步判断回复买家问题，不得不响应或直接拒绝处理。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px">二、【问题核实】</span>
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十条
        卖家对问题进行初步判断后，可通过以下渠道获取核实问题需要的相关信息。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1. 买家举证材料；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 卖家掌握的订单信息、双方约定等内容；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3. 第三方人员或者机构提供的信息；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        4. 其他。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十一条
        卖家应就以下情况提前与买家协商一致，未提前协商一致导致买家投诉，卖家应向买家解释问题发生的合理性，买家认可视为问题已解决，买家不认可，卖家应承担相应责任。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1. 卖家不接单或接单后取消订单；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 卖家未按照约定时间出餐或者交付；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3. 商品未送达约定位置；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        4. 赠品未与交易商品一同发货、延期发货；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        5. 有瑕疵、看着不新鲜等人眼可辨的物品质量问题；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        6. 其他情形。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十二条 卖家可通过以下文件凭证或信息对买家投诉的问题进行核实。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1. 前台商品展示页、交易快照页信息（包括备注信息）；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 发货打包视频；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3. 订单发货时间、配送时间、送达时间等履约信息；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        4. 证明双方有提前约定内容的聊天记录、电话录音等；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        5. 买家提供的交付商品的完整照片、细节图；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        6. 第三方提供的口头描述、聊天记录、电话录音等；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        7. 权威机构出具的质量检测报告、产品合格证等；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        8. 其他的文件凭证。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十三条
        卖家就买家投诉的以下问题，可以根据第十二条列明的凭证材料及信息核实投诉问题是否成立。卖家通过核实凭证材料的真实性、完整性、一致性，认为申请问题不存在疑义的，视为投诉成立。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1. 商品的介绍（单位、图片、规格等）与实际交付物不相符；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 未按照约定时间出餐、启动配送、交付商品的；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3. 商品未送到指定的位置；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        4. 交付的商品有遗漏、损坏；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        5. 交付的商品存在质量问题；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        6. 发票开错或者开具虚假的发票。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        7. 配送方额外收费；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        8. 卖家要求线下交易。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十四条 卖家对买家的举证存在疑义的，应提供反举证证明已履行了相关义务。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        三、【问题处理】
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十五条
        卖家经过核实，认为投诉问题属实无异议的，应就其违约或过错责任对问题进行处理。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十六条
        卖家可以通过平台、电话、短信、转账软件等工具，包括但不限于向买家道歉、退款、部分退款、补送商品等措施来协商解决买家问题，获得买家谅解。卖家无法完全满足买家提出的诉求时，应本着解决问题的原则，向买家解释原因，并表示歉意。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十七条
        买家不同意卖家提出的问题解决方案，出现情绪激动、语言偏激等情况的，卖家应倾听理解，积极安抚。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十八条
        平台鼓励卖家为买家提供更多服务与保障，卖家与买家经过多次友好协商沟通，仍无法达成一致导致平台介入的，平台将根据相关规则进行处理。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px">四、【平台处理流程】</span>
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第十九条
        买家就卖家的以下问题直接投诉至平台的，平台将根据系统数据等已有能力进行判责，核实问题属实后，对于买家合理的诉求将予以支持。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1. 卖家不接单；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 卖家售中私自取消订单；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3. 卖家未按照约定时间履行义务；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        4. 卖家未按约定方式交付商品问题。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十条
        买家投诉的以下问题，卖家不解决或未与买家达成一致，导致平台介入处理的，平台将通过系统数据、产品工具、举证证据等进行判责，确认属于卖家责任的，对于买家合理的诉求将予以支持：
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        1. 买家售中联系不上卖家；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        2. 商品存在质量问题（变质发霉、快过期、已过期、假货等）；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        3. 商品遗漏（少送、缺货、送错等）、商品损坏（包装破损、撒漏）；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        4. 卖家交易信息不真实（描述不符、信息错误、分量不足）；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        5. 卖家开错发票、开具虚假发票；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        6. 卖家要求线下交易；
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        7. 配送方额外收费。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十一条
        平台根据问题处理需要，通过平台系统、短信或电话等方式向卖家发送举证通知的，卖家须在规定时间内充分举证，超时未举证的，平台有权依据已有证据进行处理。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十二条
        平台先行支付买家的金额有权从卖家应结款项中扣除，卖家应结款项不足以支付的，须在规定时限内偿还平台剩余金额。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十三条
        卖家对判定的结果存在异议的，可在规定时间内提供有效申诉理由和证据完成申诉，未在规定时间内进行有效申诉，视为认可判责结果。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十四条
        因卖家投诉问题处理不当导致投诉面积扩大化，给平台带来严重影响的，平台有理由认为卖家投诉处理能力存在问题，并有权按照相关规则对卖家进行处理。
      </p>
      <h2 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        <span style="font-size: 16px">五、【特殊问题】</span>
      </h2>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十五条
        买家对有关规定不理解或者因操作不当而发起的纠纷投诉，卖家应将有关规定向买家做详细解释和说明。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十六条
        买家的纠纷投诉要求超出卖家权限，或明显违反国家法律法规或平台规则，卖家应耐心予以解释，给与买家拒绝的原因，也可为买家提出按现有规定解决问题的思路或方法。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第二十七条
        对有记忆、心理、精神障碍买家的投诉，卖家应通过诚心、耐心和有理、有节的调节，达到化解矛盾和排除其非合理要求的目的。
      </p>
      <p style="text-indent: 2em">
        第二十八条
        如果平台无法提供销售者有效姓名、电话、地址等有效信息，或者卖家无法履行退款或赔偿责任，则平台将承担相应责任。在此情况下，消费者可以向平台提出申诉，并要求平台承担相应的退款和赔偿责任，平台将对用户的损失承担兜底赔付，并向卖家追偿。
      </p>
      <h1 style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第四章 附则
      </h1>
      <p style="text-indent: 2em">
        <span style="color: #666666"
          >第<span style="font-size: 16px"
            ><span style="background-color: #ffffff">二十九</span></span
          >条 卖家</span
        >的行为，发生在本规则生效之日以前的，适用当时的规则，发生在本规则生效之日以后的，适用本规则。
      </p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6=""></p>
      <p style="text-align: start; text-indent: 2em" data-v-0c3730e6="">
        第三十条
        卖家应遵守国家法律、行政法规、部门规章等规范性文件的要求，对任何涉嫌违反国家法律、行政法规、部门规章等规范性文件的行为，本规则已有规定的，适用于本规则，本规则尚无规定的，平台有权酌情处理。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
  created() {
    this.title = this.$route.query.data;
  },
  methods: {},
};
</script>
